import React from 'react';
import { Image } from '@fashionnovateam/nova-ui-toolkit';
import { CostChange } from './CostChange';
import { DueDateChange } from './DueDateChange';
import { OtherChanges } from './OtherChanges';
import { QuantityChange } from './QuantityChange';
import { PurchaseOrderRevisionRequestedActivityDetail } from '../../../../Lib/Types/purchase-order-revision';
import { Changeback } from './Chageback';

function ActivityDueDate({
  dueDate,
  chargeback,
}: {
  dueDate: PurchaseOrderRevisionRequestedActivityDetail['due_date'];
  chargeback: PurchaseOrderRevisionRequestedActivityDetail['chargeback'];
}) {
  return (
    <div className="flex flex-col gap-3">
      <span className="text-md font-medium text-base-primary">PO Level</span>
      {dueDate && (
        <DueDateChange
          newFobShipDate={dueDate.new_fob_ship_date}
          currentFobShipDate={dueDate.old_fob_ship_date}
          originalFobShipDate={dueDate.original_fob_ship_date}
          newDueDate={dueDate.new_due_date}
          currentDueDate={dueDate.old_due_date}
          originalDueDate={dueDate.original_due_date}
          lateReason={dueDate.late_reason}
          note={dueDate.note}
        />
      )}
      {chargeback && chargeback.value !== 0 && <Changeback {...chargeback} />}
    </div>
  );
}

function ActivityItems({
  items,
}: {
  items: NonNullable<PurchaseOrderRevisionRequestedActivityDetail['items']>;
}) {
  return (
    <>
      {items.map((item) => (
        <div key={item.style_color} className="flex flex-col gap-5">
          <span className="text-md font-medium text-base-primary">
            Item Level
          </span>
          <div className="flex flex-col gap-5 p-5 border border-neutral-100 rounded-lg shadow-[0px_2px_4px_0px_#0000000A]">
            <div className="flex items-center gap-3">
              {item.image && (
                <Image src={item.image} className="max-h-10 max-w-10 rounded" />
              )}
              <span>{item.name}</span>
            </div>
            {item.sizes?.length && <QuantityChange sizes={item.sizes} />}
            {item.sizes && item.prices && (
              <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-100" />
            )}
            {item.prices && (
              <CostChange
                jrCost={item.prices.new_jr_cost}
                plusCost={item.prices.new_plus_cost}
                jrCostCurrently={item.prices.old_jr_cost}
                plusCostCurrently={item.prices.old_plus_cost}
              />
            )}
            {item.prices && item.comment && (
              <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-100" />
            )}
            {item.comment && <OtherChanges comment={item.comment} />}
          </div>
        </div>
      ))}
    </>
  );
}

export function PurchaseOrderRevisionRequestedActivity(props: {
  detail: PurchaseOrderRevisionRequestedActivityDetail;
}) {
  const { detail } = props;

  return (
    <div className="flex flex-col gap-5">
      {detail.reason_for_request && (
        <div className="flex flex-col gap-1">
          <span className="text-md font-medium text-base-primary">
            Reason for Request
          </span>
          <span className="text-xsm font-normal text-base-primary">
            {detail.reason_for_request}
          </span>
        </div>
      )}
      {(detail.due_date ||
        (detail.chargeback && detail.chargeback.value !== 0)) && (
        <ActivityDueDate
          dueDate={detail.due_date}
          chargeback={detail.chargeback}
        />
      )}
      {detail.items?.length && <ActivityItems items={detail.items} />}
    </div>
  );
}
